var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_370_23788)",
    filter: "url(#filter0_b_370_23788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0.5C10.0736 0.5 0 10.5736 0 23C0 35.4264 10.0736 45.5 22.5 45.5C34.9264 45.5 45 35.4264 45 23C45 10.5736 34.9264 0.5 22.5 0.5ZM28.2465 29.4065C28.2465 29.6225 28.1607 29.8297 28.0079 29.9825C27.8552 30.1352 27.648 30.2211 27.432 30.2211H13.6358C12.5679 30.2211 11.5438 29.7969 10.7887 29.0418C10.0336 28.2867 9.60935 27.2625 9.60935 26.1946V16.5935C9.60935 16.3774 9.69517 16.1702 9.84793 16.0175C10.0007 15.8647 10.2079 15.7789 10.4239 15.7789H24.2201C25.288 15.7789 26.3121 16.2031 27.0672 16.9582C27.8223 17.7133 28.2465 18.7374 28.2465 19.8053V29.4065ZM35.3907 29.6909C35.3907 29.7589 35.3719 29.8256 35.3366 29.8837C35.3012 29.9418 35.2505 29.989 35.1901 30.0203C35.1297 30.0515 35.0618 30.0655 34.994 30.0608C34.9261 30.056 34.8609 30.0327 34.8054 29.9934L28.947 25.842V20.1579L34.8054 16.0065C34.8609 15.9672 34.9261 15.9439 34.994 15.9392C35.0618 15.9345 35.1297 15.9485 35.1901 15.9798C35.2505 16.011 35.3012 16.0582 35.3366 16.1163C35.3719 16.1744 35.3906 16.2411 35.3907 16.3092V29.6909Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_370_23788",
    x: -14.9346,
    y: -14.4346,
    width: 74.8692,
    height: 74.8692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.4673
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_370_23788"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_370_23788",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_370_23788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.125275b16d46bd204daa8c634c52a242.svg";
export { ForwardRef as ReactComponent };